import { lazy } from 'react';
import * as routePath from '../route-path';
import * as routeName from '../route-name';
import { VoucherIcon } from 'components/Atoms/Icon';

const CodeManagement = lazy(() => import('components/Pages/CodeManagement'));
const CodeCreation = lazy(() =>
  import('components/Pages/CodeManagement/components/CreateAndUpdate')
);

export const codeRoutes = [
  {
    path: routePath.CODE_MANAGEMENT,
    component: CodeManagement,
    name: routeName.CODE_MANAGEMENT,
    showMenu: true,
    icon: VoucherIcon,
    exact: true,
    breadcrumbs: [{ name: routeName.CODE_MANAGEMENT }],
  },
  {
    path: routePath.CODE_CREATION,
    component: CodeCreation,
    name: routeName.CODE_CREATION,
    showMenu: false,
    icon: VoucherIcon,
  },
];
